import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassStart } from '@fortawesome/free-solid-svg-icons';

export const Loading = (props: any) => {

  const {
    text
  } = props;

  return (
    <div style={{width:'100%', padding:'50px', display:'flex', flexDirection:'column', alignItems:'center'}}>
      <FontAwesomeIcon icon={faHourglassStart} size='2x' />
      <div style={{marginTop:'10px'}}>
        {text || 'Aguarde...'}
      </div>
    </div>
  );

}